export enum ProcessingInstruction {
  orderCompleteOnPaymentApproval = 'ORDER_COMPLETE_ON_PAYMENT_APPROVAL',
}
